import { defineSlotRecipe } from '@chakra-ui/react';

// NativeSelect is the v3 home of v2's `Select`, and `StackedSelect` renders it.
// Same drift as input.ts; only start padding needs restoring, since v2's
// `paddingInlineEnd: 2rem` is v3's `pe: 8`. v2 set `lineHeight: normal`.
const nativeSelectSlotRecipe = defineSlotRecipe({
  slots: ['root', 'field', 'indicator'],
  // Focus and invalid as in textarea.ts and input.ts: the stock field ring
  // takes colorPalette.focusRing (gray.400 here); v2's Select used blue.500.
  base: {
    field: {
      focusRingColor: 'primary.500',
      _invalid: { focusRingColor: 'primary.500' },
    },
  },
  variants: {
    variant: {
      outline: {
        field: { _invalid: { outline: '1px solid var(--error-color)' } },
      },
    },
    size: {
      md: {
        field: {
          textStyle: 'md',
          lineHeight: 'normal',
          ps: '4',
          borderRadius: 'md',
        },
      },
    },
  },
});

export default nativeSelectSlotRecipe;
